var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag-status",class:{ circle: _vm.circle },style:({ color: _vm.color, background: _vm.background })},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }